import React, { useState, useRef, useCallback } from "react";
import ModifyReservationPrice from "./modifyReservationPrice/ModifyReservationPrice";
import { withTranslation } from "react-i18next";
import ReservationPriceClient from "../../../../shared/clients/ReservationPriceClient";
import PendingActionClient from "../../../../shared/clients/PendingActionClient";
import { RESERVATION_DEPOSIT } from "../../../../common/Constants";
import {
  displayError,
  ERROR_PROCESSING,
  isProcessingError,
} from "../../../../errors/ErrorConstants";

function DepositPricing(props) {
  const [hasError, setHasError] = useState([]);
  const [pricesApplied, setPricesApplied] = useState(false);

  const pricingRef = useRef();

  const getDealerList = useCallback(() => {
    const dealers = [];
    let dealerList = props.user.getCommonIdsWithoutSDLR();
    if (dealerList) {
      dealerList = dealerList.split(",");
      dealerList.forEach((dealer) => {
        const formattedDealer = props.user.reformatCommonId(dealer);
        dealers.push(
          props.user.dealerGroupingsMap[formattedDealer].completeDealerId
        );
      });
    }
    return dealers;
  }, [props.user]);

  const updatePendingActions = useCallback((nsc = false) => {
    if (nsc) {
      PendingActionClient.removeNscPendingAction(
        props.user,
        RESERVATION_DEPOSIT,
        5
      )
        .then(() => props.getPendingActions())
        .catch((error) => {
          if (isProcessingError(error)) {
            setHasError([ERROR_PROCESSING]);
          }
        });
    } else {
      PendingActionClient.removeDealerPendingAction(
        props.user,
        getDealerList(),
        RESERVATION_DEPOSIT,
        5
      )
        .then(() => props.getPendingActions())
        .catch((error) => {
          if (isProcessingError(error)) {
            setHasError([ERROR_PROCESSING]);
          }
        });
    }
  }, [props.user, props.getPendingActions, getDealerList]);

  const updateReservationPrice = useCallback((reservationsObject) => {
    const reservations = reservationsObject.reservations;
    props.hideOrShow(true);

    if (props.isNsc) {
      ReservationPriceClient.updateNscReservationPrice(
        props.user,
        reservations
      )
        .then(() => {
          updatePendingActions(true);
        })
        .catch((error) => {
          if (isProcessingError(error)) {
            setHasError([ERROR_PROCESSING]);
          }
        })
        .finally(() => {
          props.hideOrShow(false);
          setPricesApplied(true);
        });
    } else {
      ReservationPriceClient.updateDealerReservationPrice(
        props.user,
        reservations,
        getDealerList()
      )
        .then(() => {
          updatePendingActions();
        })
        .catch((error) => {
          if (isProcessingError(error)) {
            setHasError([ERROR_PROCESSING]);
          }
        })
        .finally(() => {
          props.hideOrShow(false);
          setPricesApplied(true);
        });
    }
  }, [props.hideOrShow, props.isNsc, props.user, updatePendingActions, getDealerList]);

  if (displayError(hasError)) {
    throw new Error(hasError[0]);
  }

  return (
    <div>
      <ModifyReservationPrice
        {...props}
        formRef={pricingRef}
        fromQuickstart={false}
        onSubmit={updateReservationPrice}
        pricesApplied={pricesApplied}
      />
    </div>
  );
}

export default withTranslation("emp")(DepositPricing);
